import {INIT_SIGNOUT, PAYEE_INFO, DEVELOPMENT_ENVIRONMENT} from '../Actions/actionTypes';

const INIT_STATE = {
    email: null,
    canBeSubmitted: false,
    phoneCode: '+91',
    phoneNumber: null,
    devEnvStatus: false
};

const Checkout = (state = INIT_STATE, action) => {

    switch(action.type){

        case INIT_SIGNOUT:
            return INIT_STATE;

        case PAYEE_INFO:
            return {
                ...state,
                ...action.info
            };

        case DEVELOPMENT_ENVIRONMENT:
            return{
                ...state,
                devEnvStatus: action.status
            }

        default:
            return state;
    }
}

export default Checkout;